import { gql, useQuery } from '@apollo/client';

const getEventLocationsQueryGQL = gql`
    query {
        getEventLocations
    }
`;

export const useGetEventLocationsGQLQuery = () => useQuery(getEventLocationsQueryGQL);
